import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IUITKSelectItemProps } from '@uitk/angular';
import { Subscription } from 'rxjs';
import { OrderComponent } from '../order/order.component';
import { Mode } from '../../../enums/mode.enum';
import { OrderDto } from '../../../dtos/order-dto.model';
import { ConfigService } from '../../../services/config.service';
import { ModeService } from '../../../services/mode.service';
import { OrderService } from '../../../services/order.service';
import { SwalAlert } from '../../../helpers/alert';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { AccountingService } from '../../../services/accounting.service';
import { InvoicesListDto } from '../../../dtos/invoices-list-dto.model';

@Component({
  selector: 'app-additional-actions',
  templateUrl: './additional-actions.component.html',
  styleUrls: ['./additional-actions.component.css']
})

export class AdditionalActionsComponent implements OnInit {
  @ViewChild(OrderComponent) orderComponent: OrderComponent | undefined;
  disableAmaKeyButton = false;
  amaKeyButtonsubscription: Subscription | undefined;
  orderIsReadySubscription: Subscription | undefined;
  Mode = Mode;
  showContainer = false;
  showReturnsButton = false;
  showReturnEntryButton = false;
  disableAddNewReturn: boolean = true;
  isButtonPanelCollapsed = true;
  // tracks whether the component/order is currently active (used in edit flow)
  isActive: boolean = false;
  msId: string = '';
  orderLocked = false;
  disableOrderType: boolean = true;
  disableOrderStatus: boolean = true;
  disableSourceCode: boolean = true;
  disableListCode: boolean = true;
  disablePromoCode: boolean = true;
  disableWebRef: boolean = true;
  disableSalesPerson: boolean = true;
  orderTypeList: IUITKSelectItemProps[] = [];
  sendEmailDialog = { show: false };
  notesDialog = { show: false };
  packingSlipNotesDialog = { show: false };
  invoiceNotesDialog = {show: false};
  returnsDialog = { show: false };
  amaKeyDialog = { show: false };
  voidOrderDialog = { show: false };
  shipAndProcessDialog = { show: false };
  removeHoldDialog = { show: false };
  creditRebillDialog = { show: false };
  generatePackingSlipDialog = { show: false };
  showAttachmentsDialog = { show : false };
  @Input() enteredByUserRole : string | null = null;
  swalAlert = new SwalAlert();
  invoices: InvoicesListDto[] | null= [];
  disableRebillBtn = false;
  constructor(
    public readonly modeService: ModeService,
    public readonly orderService: OrderService,
    private readonly router: Router,
    private readonly authorizationService: AuthorizationService,
    public readonly configService: ConfigService,
    public readonly accountingService: AccountingService) {
  }

  ngOnInit(): void {
    this.orderIsReadySubscription = this.orderService.orderIsReady.subscribe(() => {
      setTimeout(() => {
        this.isButtonPanelCollapsed = !this.configService.hasResource("OrderInquiryAdditionalActionsExpand");
        if (this.orderService.orderDto.hasReturns) {
          this.showReturnsButton = true;
          this.showReturnEntryButton = false;
        } else {
          this.showReturnsButton = false;
          if (this.configService.hasResource("OrderInquiryAdditionalActionsAddNewReturnsButton")) {
            this.showReturnEntryButton = true;
          }
          else
          {
            this.showReturnEntryButton = false;
          }
        }

        for (let i = 0; i < this.orderService.orderDto.orderDetailDtos.length; i++) {
          const lineItem = this.orderService.orderDto.orderDetailDtos[i];
          if (lineItem.orderDetailStatus !== ' ' || lineItem.shippedQuantity > 0) {
            this.disableAddNewReturn = false;
            break;
          }
        }
        this.disableAmaKeyButton = !this.orderService.orderDto.orderDetailDtos.some(item => item.productDto.requiresAmaKey === true);
        this.disableRebill();
      }, 0);
    });

    this.amaKeyButtonsubscription = this.orderService.getAmaKeyButtonMode().subscribe(isDisabled => this.disableAmaKeyButton = isDisabled);
  }

  navigateReturnEntry(): void {
    this.router.navigate(['/return-entry']);
  }

  navigateToInvoices(orderDto: OrderDto): void {
    this.router.navigate([]).then(() => {
      window.open('/invoices/' + orderDto.id, '_blank');
    });
  }

  resendOrder(): void {
    this.orderService.resendOrder(this.orderService.orderDto.id);
  }

  async revertToQuote() {
    if (this.orderService.orderDto.multiYearDtos.some(x => x.shippedAmount > 0)){
      await this.swalAlert.alert("Cannot convert to Quote as Items within the multiyear order has shipped.");
      return;
    }
    let getOrderDetails : OrderDto  = {...this.orderService.orderDto};
    getOrderDetails.orderType = 'Q'
    getOrderDetails.orderStatus = ' ';
    getOrderDetails.exceptionReasonCode = null;
    getOrderDetails.holdReasonCode = null;
    this.orderService.setLockOrder(this.orderService.orderDto.id, this.authorizationService.getMyMSId(), false).subscribe(
      (data) => {          
        this.orderService.saveOrderToDatabase(getOrderDetails).then(async res => {
          await this.orderService.ConvertOrdersToQuote(this.orderService.orderDto.id, this.authorizationService.getMyMSId());
          this.router.navigateByUrl('/order-entry?orderId=' + this.orderService.orderDto.id);
        })
        
    });
    
  }

  clearInUse(): void {
    this.orderService.clearInUse(this.orderService.orderDto.id);
  }

  clearPending(): void {
    this.orderService.clearPending(this.orderService.orderDto.id);
  }

  async convertException(): Promise<void> {
    await this.orderService.convertException(this.orderService.orderDto.id);
  }

  async showVoidOrderDialog(): Promise<void> {
    if ((this.configService.hasResource('TucsonAllowPrintProducts') && !this.configService.hasResource('TucsonAllowElectronicProducts'))) {
      if (this.orderService.orderDto.salesOrganization === 'Optum') {
        await this.swalAlert.alert(`You are not authorized to void the order.`);
        this.voidOrderDialog.show = false;
        return;
      }
    }
    else if (!this.configService.hasResource('TucsonAllowPrintProducts') && this.configService.hasResource('TucsonAllowElectronicProducts')) {
      if (this.orderService.orderDto.salesOrganization === 'Shutterfly') {
        await this.swalAlert.alert(`You are not authorized to void the order.`);
        this.voidOrderDialog.show = false;
        return;
      }
    }

    this.voidOrderDialog.show = true;
  }
   async edit(bypassPending: boolean = false): Promise<void> {
    
    // Set isCreditRebill flag to true when Credit/Rebill button is clicked
    this.orderService.orderDto.isCreditRebill = true;
    this.orderService.creditRebillFlag = true;
    this.orderService.orderDto.returnCode = 'REBILL';

    // Immediately show Open in the status pill — do this right on click,
    // before any async work, so the user sees it straight away.
    this.orderService.orderDto.orderStatus = ' ';
    this.orderService.orderStatus = 'Open';
    this.orderService.calculateOrderStatus(this.orderService.orderDto);
    
    // NOTE: sourceCode and returnCode are set to 'REBILL' only at save time
    // (in prepareCreditRebillOrder) so that reverting restores the original values.
    
    //Allowing edit when displayShipToLinkSaveButton is true to avoid Order lock issue when saving Ship To Contacts with no Edit access
    if (!this.configService.hasResource('OrderInquiryEditButton') && (!this.orderService.displayShipToLinkSaveButton)) {
      await this.orderService.accountContactValidationBR();
      return;
    }
      
      if (this.isActive) {
        this.modeService.mode = Mode.View;
        return;
      }
      this.checkResources();

      this.orderService.orderDto.yearPanelButtonsDisable = true;
      const currentUser = JSON.parse(localStorage.getItem('currentUser') as any);

      if (localStorage.getItem('isByPass') === 'true') {
        this.msId = 'byPass'
      }
      
      if (currentUser != null) {
        this.msId = this.authorizationService.getMyMSId();
      }
    return new Promise(resolve => {

      const editOrderTxt = "Editing order";
      this.modeService.addToWaitList(editOrderTxt);
      this.orderService.setLockOrder(this.orderService.orderDto.id, this.msId, bypassPending).subscribe(
        (data: OrderDto) => {
          this.modeService.removeFromWaitList(editOrderTxt);
          // Create backup copy so I can revert if needed.

          const contactBinding = this.orderService.orderDto.orderByContactBinding;
          const shipToContactBinding = this.orderService.orderDto.shipToContactBinding;
          const orderNotes = this.orderService.orderDto.orderNotes;
          const systemComments = this.orderService.orderDto.systemComments;
          const freeFormComments = this.orderService.orderDto.freeFormComments;
          const isCreditRebill = this.orderService.orderDto.isCreditRebill;
          const returnCode = this.orderService.orderDto.returnCode;
          const originalSourceCode = this.orderService.orderDto.sourceCode; // preserve original source code
          // Preserve isChecked state on order details before overwriting with fresh lock data
          const currentOrderDetails = new Map(
            this.orderService.orderDto.orderDetailDtos.map(detail => [
              detail.id, 
              {
                isChecked: detail.isChecked
              }
            ])
          );

          this.orderService.orderDto = data;

          this.orderService.orderDto.lastShipmentMethod = this.orderService.orderDto.shipmentMethod;
          this.orderService.orderDto.orderByContactBinding = contactBinding;
          this.orderService.orderDto.shipToContactBinding = shipToContactBinding;
          this.orderService.orderDto.orderNotes = orderNotes;
          this.orderService.orderDto.systemComments = systemComments;
          this.orderService.orderDto.freeFormComments = freeFormComments;
          this.orderService.orderDto.isCreditRebill = isCreditRebill;
          
           if (isCreditRebill) {
            this.orderService.orderDto.returnCode = returnCode;
            this.orderService.orderDto.sourceCode = originalSourceCode; // keep original order's source code unchanged
            this.orderService.orderDto.orderStatus = ' ';
          }
          // Restore isChecked state after getting fresh data
          if (isCreditRebill) {
            this.orderService.orderDto.orderDetailDtos.forEach(detail => {
              const preserved = currentOrderDetails.get(detail.id);
              if (preserved) {
                detail.isChecked = preserved.isChecked;
              }
            });
          }
          if(this.orderService.orderDto.shipToDto.company === '' || this.orderService.orderDto.shipToDto.company === null || this.orderService.orderDto.shipToDto.company === undefined){
            this.orderService.orderDto.shipToDto.company = this.orderService.orderDto.billToDto.abbreviatedCompany ?? '';
          }

          this.orderService.orderDtoBackup = JSON.parse(JSON.stringify(this.orderService.orderDto)) as OrderDto;
          this.orderService.orderDtoBackup.inUseBy = null;
          this.orderService.orderDtoBackup.inUseDate = null;

          this.modeService.mode = Mode.Edit;
          this.orderService.orderDto.yearPanelButtonsDisable = true;
          this.orderLocked = true;
          this.orderService.recalculateFields(this.orderService.orderDto);
          if (isCreditRebill) {
            // Must be set AFTER recalculateFields because calculateOrderStatus (called
            // inside recalculateFields) would otherwise overwrite it.
            this.orderService.orderStatus = 'Open';
          }
          this.setOrderTypeList();
          this.checkOrderHeaderResource();
          this.orderService.onCheckResources.next();
          resolve();
        }, async error => {
          this.modeService.removeFromWaitList('Editing order');
          this.modeService.mode = Mode.View;
          await this.swalAlert.alert('Order is already in use and it is locked.');
          resolve();
        });
    });
  }

  setOrderTypeList(){
    if (this.configService.orderEntryFeature && (this.orderService.orderDto.orderType === 'E' || this.orderService.orderDto.orderType === ' ')) {
      this.orderTypeList = [
        { id: 'E', label: 'Exception', value: 'E' },
        { id: ' ', label: 'Order', value: ' ' },
      ];
    } else if (!this.configService.orderEntryFeature && (this.orderService.orderDto.orderType === 'Q' || this.orderService.orderDto.orderType === ' ')) {
      this.orderTypeList = [
        { id: 'Q', label: 'Quote', value: 'Q' },
        { id: ' ', label: 'Order', value: ' ' },
      ];
    } else {
      this.orderTypeList = [
        { id: 'R', label: 'Return', value: 'R' },
        { id: 'A', label: 'Authorization', value: 'A' },
      ];
    }
  }

    checkResources(){   
      this.modeService.mode = Mode.Edit;
      if ((this.orderService.orderDto.orderType === 'Q' && this.configService.hasResource('OrderHeaderType')) ||
        (this.orderService.orderDto.orderType === ' ' && this.configService.hasResource('OrderHeaderTypeOToQ'))
        && this.configService.hasResource('AllowOrderChangeToException'))
      {
        this.disableOrderType = false;
      }
      else
      {
        this.disableOrderType = true;
      } 
      
      this.checkOrderHeaderResource();
    }
  
    checkOrderHeaderResource(){
      if (this.configService.hasResource('OrderHeaderStatus')) {
        this.disableOrderStatus = false;
      }
  
      if (this.configService.hasResource('OrderHeaderSourceCode')) {
        this.disableSourceCode = false;
      }
  
      if (this.configService.hasResource('OrderHeaderListCode')) {
        this.disableListCode = false;
      }
  
      if (this.configService.hasResource('OrderHeaderPromoDetails')) {
        this.disablePromoCode = false;
      }
  
      if (this.configService.hasResource('OrderHeaderPromoCode')) {
        this.disablePromoCode = false;
      }
  
      if (this.configService.hasResource('OrderHeaderWebRef')) {
        this.disableWebRef = false;
      }
  
      if (this.configService.hasResource('OrderHeaderSalesperson')) {
        this.disableSalesPerson = false;
      }
    }

  async disableRebill() {
    let hasClosedLineItems = this.orderService.orderDto.orderDetailDtos.some(
      item => item.orderDetailStatus === 'C' || (item.shippedQuantity > 0 && item.orderDetailStatus !== ' ')
    );
    let hasRebillLineItems =  this.orderService.orderDto.orderDetailDtos.some(element => element.isRebill || element.returnedShippedQuantity != element.returnedQuantity  ||element.shippedQuantity + element.returnedQuantity > 0);
    this.invoices = await this.accountingService.getInvoices(this.orderService.orderDto.originalOrderId==null?this.orderService.orderDto.id:this.orderService.orderDto.originalOrderId);
    this.disableRebillBtn =  hasClosedLineItems && hasRebillLineItems && (this.invoices != null && this.invoices.length > 0);
  }

  ngOnDestroy() {
    this.orderIsReadySubscription?.unsubscribe();
    this.amaKeyButtonsubscription?.unsubscribe();
  }
}
